import React from "react";

function LoadingScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[#000C1A]">
      <div className="text-center">
        <div className="w-24 h-24 border-4 border-cyan-400 border-t-transparent rounded-full animate-spin mx-auto"></div>
        <div className="mt-6 text-cyan-400 font-mono">
          <p className="text-xl">INITIALIZING SYSTEMS</p>
          <div className="flex justify-center mt-2">
            <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse mx-1"></div>
            <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse mx-1 animation-delay-200"></div>
            <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse mx-1 animation-delay-400"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(LoadingScreen);
